import { Controller } from '@hotwired/stimulus';

//Import TinyMCE
import 'tinymce/tinymce';

//A theme is also required
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin.min.css';

//Any plugins you want to use has to be imported
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import '../tinymce/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';

export default class extends Controller {
  static targets = ['field'];

  static values = {
    imagesUploadUrl: String,
  };

  connect() {
    this.fieldTargets.forEach((field) => {
      const height = field.dataset.editorHeight || 360;
      tinymce.init({
        target: field,
        height: height,
        branding: false,
        menubar: false,
        language_url: '/vendors/tinymce/langs/ko_KR.js',
        language: 'ko_KR',
        content_css: '/vendors/tinymce/skins/content/default/content.css',
        content_style:
          "@import url('https://fonts.googleapis.com/earlyaccess/nanumgothic.css'); @import url('https://fonts.googleapis.com/earlyaccess/nanummyeongjo.css');" +
          `.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
            white-space: pre-line;
            color: #9ca3af;
            }`,
        skin_url: '/vendors/tinymce/skins/ui/oxide',
        contextmenu: false,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount autolink table',
        ],
        toolbar: [
          'formatselect | fontselect | fontsizeselect | forecolor | bold italic underline backcolor | ' +
            'alignleft aligncenter alignright alignjustify | removeformat | ' +
            'bullist numlist outdent indent | link  image media | table hr | code',
        ],
        toolbar_mode: 'wrap',
        fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt',
        font_formats: '시스템 글꼴=-apple-system, system-ui; 나눔명조=Nanum Myeongjo; 나눔고딕=Nanum Gothic',
        block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2',
        //block_unsupported_drop: false,
        file_picker_types: 'file image',
        convert_urls: false,
        images_upload_url: this.imagesUploadUrlValue,
        automatic_uploads: true,
        paste_data_images: true,
        images_file_types: 'jpeg,jpg,png,gif,bmp',
        block_unsupported_drop: true,
        image_title: true,
        image_description: false,

        images_upload_handler: (blobInfo, success, failure, progress) => {
          let xhr, formData;

          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', this.imagesUploadUrlValue);
          for (const [key, value] of Object.entries(window._csrf)) {
            xhr.setRequestHeader(key, value);
          }

          xhr.upload.onprogress = function (e) {
            progress((e.loaded / e.total) * 100);
          };

          xhr.onload = function () {
            var json;

            if (xhr.status === 403) {
              failure('HTTP Error: ' + xhr.status, { remove: true });
              return;
            }

            if (xhr.status < 200 || xhr.status >= 300) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }

            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.location != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }

            success(json.location);
          };

          xhr.onerror = function () {
            failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
          };

          formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());
          xhr.send(formData);
        },
        mobile: {
          toolbar_mode: 'wrap',
          toolbar: [
            'formatselect | fontselect | fontsizeselect | forecolor | bold italic underline backcolor | ' +
              'alignleft aligncenter alignright alignjustify | removeformat | ' +
              'bullist numlist outdent indent | link  image media | table | code',
          ],
        },
        setup: (editor) => {
          editor.ui.registry.addButton('hr', {
            icon: 'hr',
            tooltip: '수평선 추가합니다.',
            onAction: () => {
              editor.insertContent('<hr>');
            },
          });
          editor.ui.registry.addIcon('hr', '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<mask id="mask0_223_5268" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">\n' +
            '<rect width="24" height="24" fill="#D9D9D9"/>\n' +
            '</mask>\n' +
            '<g mask="url(#mask0_223_5268)">\n' +
            '<path d="M4 13V11H20V13H4Z" fill="#1C1B1F"/>\n' +
            '</g>\n' +
            '</svg>\n');
        },
      });
    });
  }
  disconnect() {
    this.fieldTargets.forEach((field) => {
      tinymce.get(field.id).remove();
    });
  }
}
